import React from 'react';

const Message = ({ variant = 'info', children }) => {
  const getVariantClass = () => {
    switch (variant) {
      case 'danger':
        return 'bg-red-500';
      case 'success':
        return 'bg-green-500';
      case 'warning':
        return 'bg-yellow-500';
      default:
        return 'bg-blue-500';
    }
  };

  return (
    <div className={`${getVariantClass()} text-white p-3 rounded-md my-3`}>
      {children}
    </div>
  );
};

export default Message;